import { Component } from "react";
import "./ChangeUserPassword.css";
import { changePassword, getSessionUser } from "services/users/auth";
import { Navigate } from "react-router-dom";
import Page from "./../../components/page/PageContent/PageContent";
import Button from "./../../components/formElements/Button/Button";

export default class ChangeUserPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      old: "",
      password: "",
      confirmPassword: "",
      errors: "",
      submitted: false,
      showSpinner: false,
      touched: {
        old: false,
        password: false,
        confirmPassword: false,
      },
      redirect: false,
    };

    this.emailChanged = this.emailChanged.bind(this);
    this.oldChanged = this.oldChanged.bind(this);
    this.passwordChanged = this.passwordChanged.bind(this);
    this.confirmPasswordChanged = this.confirmPasswordChanged.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  emailChanged(event) {
    this.setState({ email: event.target.value });
  }

  oldChanged(event) {
    this.setState({ old: event.target.value });
  }

  passwordChanged(event) {
    this.setState({ password: event.target.value });
  }

  confirmPasswordChanged(event) {
    this.setState({ confirmPassword: event.target.value });
  }

  handleBlur = field => () => {
    this.setState({
      touched: { ...this.state.touched, [field]: true },
    });
  };

  changeUserPassword = event => {
    event.preventDefault();
    this.setState({ submitted: true, errors: "" });
    if (!this.isFormValid() || !this.testPasswordsMatch()) {
      if (!this.testPasswordsMatch()) {
        this.setState({ errors: "Passwords don’t match. Please, try again" });
      }
      return;
    }

    this.setState({ showSpinner: true });

    changePassword({
      old_passwd: this.state.old,
      new_passwd: this.state.password,
      email: this.props.unauth ? this.state.email : getSessionUser().profile.email,
    })
      .then(() => {
        this.setState({ redirect: true, showSpinner: false });
      })
      .catch(respBody => {
        let errors = null;
        if (respBody && respBody.errors) {
          errors = respBody.errors.map((error, index) => (
            <span key={index}>{error.description}</span>
          ));
        } else {
          errors = respBody;
        }
        this.setState({ errors: errors, showSpinner: false });
      });
  };

  isFormValid = () => {
    return (
      !this.emptyField(this.state.old) &&
      !this.emptyField(this.state.password) &&
      !this.emptyField(this.state.confirmPassword) &&
      ((this.props.unauth && !this.emptyField(this.state.email)) || !this.props.unauth)
    );
  };

  emptyField = value => {
    return !value && value.length === 0;
  };

  testPasswordsMatch = () => {
    return this.state.password === this.state.confirmPassword;
  };

  isInvalid = (name, value) => {
    return this.emptyField(value) && (this.state.touched[name] || this.state.submitted);
  };

  render() {
    if (this.state.redirect) {
      const path = this.props.unauth ? "/sign_in" : "/";
      return <Navigate to={path} replace />;
    }

    let invalidFields = {
      old: this.isInvalid("old", this.state.old),
      password: this.isInvalid("password", this.state.password),
      confirmPassword: this.isInvalid("confirmPassword", this.state.confirmPassword),
      email: this.props.unauth && this.isInvalid("email", this.state.email),
    };

    return (
      <Page title="Change Password" name="change-password" noHeader={this.props.unauth}>
        <form onSubmit={this.changeUserPassword}>
          {this.props.unauth && (
            <div className="width-100">
              <label htmlFor="email" className="width-30">
                * Email
              </label>
              <input
                name="email"
                id="email"
                type="email"
                value={this.state.email}
                onBlur={this.handleBlur("email")}
                className={invalidFields.email ? "error" : ""}
                onChange={this.emailChanged}
              />
            </div>
          )}
          <div className="width-100">
            <label htmlFor="old" className="width-30">
              * Old Password
            </label>
            <input
              name="old"
              id="old"
              type="password"
              value={this.state.old}
              onBlur={this.handleBlur("old")}
              className={invalidFields.old ? "error" : ""}
              onChange={this.oldChanged}
            />
          </div>
          <div className="width-100">
            <label htmlFor="password" className="width-30">
              * New Password
            </label>
            <input
              name="password"
              id="password"
              type="password"
              value={this.state.password}
              onBlur={this.handleBlur("password")}
              className={invalidFields.password ? "error" : ""}
              onChange={this.passwordChanged}
            />
          </div>
          <div className="width-100">
            <label htmlFor="confirm" className="width-30">
              * Confirm New Password
            </label>
            <input
              name="confirm"
              id="confirm"
              type="password"
              value={this.state.confirmPassword}
              onBlur={this.handleBlur("confirmPassword")}
              className={invalidFields.confirmPassword ? "error" : ""}
              onChange={this.confirmPasswordChanged}
            />
          </div>
          {this.state.errors && <div className="talaera-error">{this.state.errors}</div>}

          <div className="actions">
            <Button className="btn" onClick={this.changeUserPassword}>
              Change
            </Button>
          </div>
        </form>
      </Page>
    );
  }
}
